module.exports = __webpack_public_path__ + "static/media/remove-device-scr.30d12f38.png";